import React from 'react';

import { Checkbox, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { getEnvironment } from '../../../utils/environment';
import AdminAuthContainer from '../AdminAuthContainer';
import AdminSettingsContainer from '../AdminSettingsContainer';
import { H2 } from '../styles/headings';
import { AdminControlCheckbox } from '../utils/AdminControlCheckbox';

const StyledFormGroupContainer = styled.div`
    margin-left: 10px;
    margin-bottom: 28px;
`;

const ProductFeedbackSettings = () => {
    const { adminSettings, setAdminSettings } = useContainer(AdminSettingsContainer);
    const { isAdmin } = useContainer(AdminAuthContainer);
    const { featureSettings } = adminSettings;
    const { t } = useTranslation('admin_settings');

    const handlePromptTeachersForFeedback = (event: React.ChangeEvent<HTMLInputElement>) => {
        featureSettings[event.target.id] = event.target.checked;

        setAdminSettings({ ...adminSettings });
    };

    const { environment } = getEnvironment();

    // @TODO --> chase: remove environment check when ready for test and prod
    if (environment === 'dev') {
        return (
            <>
                <H2>{t('product-feedback.header')}</H2>
                <StyledFormGroupContainer>
                    <FormGroup>
                        <AdminControlCheckbox
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={featureSettings.promptTeachersForFeedback}
                                    onChange={handlePromptTeachersForFeedback}
                                    id="promptTeachersForFeedback"
                                    name="promptTeachersForFeedback"
                                    disabled={!isAdmin}
                                />
                            }
                            label={t('product-feedback.prompt-instructors') as string}
                        />
                    </FormGroup>
                    <FormGroup>
                        <AdminControlCheckbox
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={featureSettings.promptStudentsForFeedback}
                                    onChange={handlePromptTeachersForFeedback}
                                    id="promptStudentsForFeedback"
                                    name="promptStudentsForFeedback"
                                    disabled={!isAdmin}
                                />
                            }
                            label={t('product-feedback.prompt-students')}
                        />
                    </FormGroup>
                </StyledFormGroupContainer>
            </>
        );
    }

    return null;
};

export default ProductFeedbackSettings;
